import React, { useEffect, useState } from "react";
import {
	AntdInput,
	AntdTable,
	BodyContainer,
	CompaginationDiv,
	Container,
	FilterContainer,
	HeaderContainer,
	StepContainer,
} from "./styles";
import { Button, DatePicker, Select } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import moment from "moment";
import { COLORS, SIZES, Typo } from "../../../../layout/theme";

export default function CodeChangesList({
	rangeDate,
	handleSelectedDate,
	selectedPharmacy,
	handleSelectPharmacy,
	pharmacies,
	selectedDistributor,
	handleSelectDistributor,
	distributors,
	selectedPointOfSale,
	handleSelectPointOfSale,
	pointsOfSales,
	selectedLaboratory,
	handleSelectLaboratory,
	laboratories,
	handleDeleteFilters,
	codeChangeList,
	isLoading,
	searchInfo,
	handleDecrement,
	handlePageChange,
	handleIncrement,
	paginationInputValue,
	setPaginationInputValue,
	dateFrom,
	dateTo,
}) {
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const columns = [
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Droguería
				</div>
			),
			dataIndex: "distributorName",
			render: (value, record) => (
				<Typo level={7} type="grey">
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Farmacia
				</div>
			),
			dataIndex: "pharmacyName",
			render: (value, record) => (
				<Typo level={7} type="grey">
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					PDV
				</div>
			),
			dataIndex: "pointOfSaleName",
			render: (value, record) => (
				<Typo level={7} type="grey">
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Codigo anterior
				</div>
			),
			dataIndex: "oldCode",
			render: (value, record) => (
				<Typo level={7} type="warning">
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Codigo nuevo
				</div>
			),
			dataIndex: "newCode",
			render: (value, record) => (
				<Typo level={7} type="success">
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Modificado por
				</div>
			),
			dataIndex: "sellerId",
			render: (value, record) => (
				<Typo level={7} type="secondary">
					{record.firstName} {record.lastName}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Laboratorio
				</div>
			),
			dataIndex: "laboratoryName",
			render: (value, record) => (
				<Typo level={7} type="secondary">
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Fecha modificacion
				</div>
			),
			width: 140,
			dataIndex: "created",
			render: (value, record) => (
				<Typo level={7} type="muted">
					{moment(value).format("DD-MM-YYYY")}
				</Typo>
			),
		},
	];

	return (
		<StepContainer>
			<HeaderContainer>
				<Container>
					<FilterContainer>
						<Typo type="secondary" level={6}>
							Fecha
						</Typo>
						{rangeDate ? (
							<DatePicker.RangePicker
								format="DD/MM/YYYY"
								value={rangeDate}
								placeholder={["Desde", "Hasta"]}
								onChange={(e) => handleSelectedDate(e)}
								style={{ width: 200 }}
								disabled={isLoading}
							/>
						) : (
							<DatePicker.RangePicker
								format="DD/MM/YYYY"
								onChange={(e) => handleSelectedDate(e)}
								placeholder={["Desde", "Hasta"]}
								style={{ width: 200 }}
								disabled={isLoading}
							/>
						)}
					</FilterContainer>
					<FilterContainer>
						<Typo type="secondary" level={6}>
							Droguería
						</Typo>
						<Select
							showSearch
							allowClear
							placeholder="Droguería"
							optionFilterProp="children"
							value={selectedDistributor}
							onChange={(e, o) => handleSelectDistributor(e, o)}
							filterOption={(input, option) =>
								(option?.label ?? "")
									.toLowerCase()
									.includes(input.toLowerCase())
							}
							options={distributors}
							style={{ width: 200 }}
							disabled={isLoading}
						/>
					</FilterContainer>
				</Container>
				<Container>
					<FilterContainer>
						<Typo type="secondary" level={6}>
							Farmacia
						</Typo>
						<Select
							showSearch
							allowClear
							placeholder="Farmacia"
							optionFilterProp="children"
							value={selectedPharmacy}
							onChange={(e, o) => handleSelectPharmacy(e, o)}
							filterOption={(input, option) =>
								(option?.label ?? "")
									.toLowerCase()
									.includes(input.toLowerCase())
							}
							options={pharmacies}
							style={{ width: 200 }}
							disabled={isLoading}
						/>
					</FilterContainer>
					<FilterContainer>
						<Typo type="secondary" level={6}>
							Punto de venta
						</Typo>
						<Select
							showSearch
							allowClear
							placeholder="Punto de venta"
							optionFilterProp="children"
							value={selectedPointOfSale}
							onChange={(e, o) => handleSelectPointOfSale(e, o)}
							filterOption={(input, option) =>
								(option?.label ?? "")
									.toLowerCase()
									.includes(input.toLowerCase())
							}
							options={pointsOfSales}
							style={{ width: 200 }}
							disabled={isLoading}
						/>
					</FilterContainer>
				</Container>
				<Container>
					<FilterContainer>
						<Typo type="secondary" level={6}>
							Laboratorio
						</Typo>
						<Select
							showSearch
							allowClear
							placeholder="Laboratorio"
							optionFilterProp="children"
							value={selectedLaboratory}
							onChange={(e, o) => handleSelectLaboratory(e, o)}
							filterOption={(input, option) =>
								(option?.label ?? "")
									.toLowerCase()
									.includes(input.toLowerCase())
							}
							options={laboratories}
							style={{ width: 200 }}
							disabled={isLoading}
						/>
					</FilterContainer>
					<FilterContainer></FilterContainer>
				</Container>
				<Container
					style={{ justifyContent: "flex-end", width: "200px", marginLeft: 18 }}
				>
					<FilterContainer>
						<Button
							type="primary"
							onClick={handleDeleteFilters}
							disabled={isLoading}
							style={{ width: 110 }}
						>
							Borrar filtros
						</Button>
					</FilterContainer>
				</Container>
			</HeaderContainer>
			<BodyContainer>
				<AntdTable
					dataSource={codeChangeList}
					loading={isLoading}
					columns={columns}
					pagination={false}
					scroll={{ y: "1020px" }}
				/>
				{searchInfo && searchInfo.totalRecords > 0 && (
					<CompaginationDiv>
						{searchInfo.actualPage !== 1 && (
							<Button size="small" shape="circle" onClick={handleDecrement}>
								<LeftOutlined />
							</Button>
						)}
						<AntdInput
							step={1}
							min={1}
							max={searchInfo.totalPages}
							onPressEnter={(e) => handlePageChange(e)}
							onChange={(e) =>
								setPaginationInputValue(e.target.value.toString())
							}
							defaultValue={paginationInputValue.toString()}
							value={paginationInputValue.toString()}
							addonAfter={`/ ${searchInfo.totalPages}`}
							style={{
								width: ` ${searchInfo.totalPages > 99 ? "76px" : "66px"}`,
							}}
						/>
						{searchInfo.actualPage < searchInfo.totalPages && (
							<Button
								size="small"
								shape="circle"
								onClick={handleIncrement}
								disabled={
									searchInfo.actualPage === searchInfo.totalPages ? true : false
								}
							>
								<RightOutlined />
							</Button>
						)}
					</CompaginationDiv>
				)}
			</BodyContainer>
		</StepContainer>
	);
}
